{
  "snow": {
    "image": "snow.jpg",
    "pixelSize": [
      2688,
      1520
    ],
    "center": [
      1332,
      756
    ],
    "apothems": [
      573,
      566,
      555,
      566,
      573,
      566,
      555,
      566
    ],
    "note": "Distance from the octagon center to the inner edge of the fence, in image pixels, for directions 0,45,...,315 degrees (0 = right, 90 = down)."
  }
}